import { useNavigate } from 'react-router-dom';
import braceletImage from '../../../assets/products/bracelet.png';
import livreImage from '../../../assets/products/livre.png';
import tshirtImage from '../../../assets/products/tshirt.png';

export default function VendorSection() {
  const navigate = useNavigate();

  const benefits = [
    { icon: 'ri-store-2-line', label: 'Boutique en ligne personnalisée' },
    { icon: 'ri-box-3-line', label: 'Gestion des stocks simplifiée' },
    { icon: 'ri-truck-line', label: 'Suivi des commandes en temps réel' },
    { icon: 'ri-bar-chart-grouped-line', label: 'Statistiques de ventes détaillées' },
    { icon: 'ri-notification-4-line', label: 'Notifications instantanées' },
    { icon: 'ri-secure-payment-line', label: 'Paiements sécurisés et rapides' },
  ];

  const products = [
    {
      name: 'Bible Louis Segond',
      vendor: 'Librairie Grace',
      price: '12 000 FCFA',
      cat: 'Livre',
      img: livreImage,
      rating: 4.8,
    },
    {
      name: 'Bracelet Argenté',
      vendor: 'Atelier Foi',
      price: '3 500 FCFA',
      cat: 'Accessoire religieux',
      img: braceletImage,
      rating: 4.9,
    },
    {
      name: 'Tshirt "Foi" minimaliste',
      vendor: 'Grace wear',
      price: '10 000 FCFA',
      cat: 'Mode chrétienne',
      img: tshirtImage,
      rating: 4.7,
    },
  ];

  return (
    <section id="vendors" className="bg-cream py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid grid-cols-1 items-center gap-16 lg:grid-cols-2">
          <div>
            <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-100 px-4 py-2">
              <i className="ri-store-2-line text-sm text-emerald-600"></i>
              <span className="text-sm font-semibold text-emerald-700">Pour les Vendeurs</span>
            </div>
            <h2 className="mb-6 text-4xl font-bold text-navy md:text-5xl">
              Votre boutique.
              <br />
              <span className="text-emerald-600">Vos règles.</span>
            </h2>
            <p className="mb-8 text-lg leading-relaxed text-gray-500">
              Rejoignez des centaines de vendeurs qui font confiance à Foi Senegal pour développer leur activité commerciale. Publiez vos produits, gérez vos commandes et suivez vos revenus depuis un tableau de bord tout-en-un.
            </p>

            <div className="mb-10 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {benefits.map((benefit) => (
                <div key={benefit.label} className="flex items-center gap-3">
                  <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-emerald-100">
                    <i className={`${benefit.icon} text-sm text-emerald-600`}></i>
                  </div>
                  <span className="text-sm font-medium text-gray-700">{benefit.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col gap-4 sm:flex-row">
              <button
                onClick={() => navigate('/register')}
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-xl bg-navy px-6 py-3.5 text-sm font-bold text-white transition-all hover:bg-navy-light"
              >
                <i className="ri-store-2-line"></i>
                Devenir vendeur
              </button>
              <div className="flex items-center gap-3 text-sm text-gray-500">
                <div className="flex -space-x-2">
                  {[
                    'https://readdy.ai/api/search-image?query=african%20woman%20portrait%20professional%20vendor%20smiling%20warm&width=32&height=32&seq=av1&orientation=squarish',
                    'https://readdy.ai/api/search-image?query=african%20man%20portrait%20professional%20vendor%20confident%20warm&width=32&height=32&seq=av2&orientation=squarish',
                    'https://readdy.ai/api/search-image?query=african%20woman%20entrepreneur%20portrait%20warm%20smile%20professional&width=32&height=32&seq=av3&orientation=squarish',
                  ].map((src) => (
                    <img key={src} src={src} alt="" className="h-8 w-8 rounded-full border-2 border-white object-cover object-top" />
                  ))}
                </div>
                <span>
                  <strong className="text-navy">1 200+</strong> vendeurs nous font confiance
                </span>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="grid grid-cols-3 gap-4">
              {products.map((product, index) => (
                <div
                  key={product.name}
                  className={`overflow-hidden rounded-2xl border border-gray-100 bg-white ${index === 1 ? 'mt-8' : ''}`}
                >
                  <div className="h-40 w-full overflow-hidden">
                    <img src={product.img} alt={product.name} className="h-full w-full object-cover object-top" />
                  </div>
                  <div className="p-3">
                    <span className="rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-semibold text-emerald-600">{product.cat}</span>
                    <p className="mt-2 text-sm font-bold leading-tight text-navy">{product.name}</p>
                    <p className="mt-0.5 text-xs text-gray-400">{product.vendor}</p>
                    <div className="mt-2 flex items-center justify-between">
                      <span className="text-sm font-bold text-gold-dark">{product.price}</span>
                      <div className="flex items-center gap-1">
                        <i className="ri-star-fill text-xs text-gold"></i>
                        <span className="text-xs text-gray-500">{product.rating}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="absolute -bottom-4 -left-4 rounded-xl border border-gray-100 bg-white p-3 shadow-sm">
              <div className="flex items-center gap-2">
                <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-100">
                  <i className="ri-arrow-up-line text-sm text-emerald-600"></i>
                </div>
                {/* <div>
                  <p className="text-xs font-bold text-navy">+38% ce mois</p>
                  <p className="text-xs text-gray-400">Nouvelles ventes</p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
